export const DEFAULT_SORT = [
    { id: "dynamicSwitchGroupName", desc: false, isDefault: true }
  ];
  
  export const DEFAULT_FILTER = [];
  